import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Light from 'components/headers/light';
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

const PointsPage = () => {
  const [data, setData] = useState({ total_amount: 0, points: 0 });

  // --- LOGIQUE D'EXTRACTION DU CUSTOM_ID ---
  const userStr = localStorage.getItem("user");
  const userData = userStr ? JSON.parse(userStr) : null;
  const customId = userData ? userData.custom_id : null;
  // -----------------------------------------

  useEffect(() => {
    if (customId) {
      // On utilise le customId extrait (CFDALAL335) pour l'appel API
      axios.get(`https://plateformewmg.cloud/api/loyalty/${customId}`)
        .then(res => setData(res.data))
        .catch(err => console.error("Erreur API Loyalty:", err));
    }
  }, [customId]);

  const handleGetPromoCode = () => {
    const discountAmount = data.points * 10;
    
    Swal.fire({
      title: "Votre Récompense Fidélité",
      html: `
        <p>Vous avez <strong>${data.points} points</strong>.</p>
        <p>Remise disponible : <strong>${discountAmount} DH</strong></p>
        <hr>
        <p>Utilisez votre Code Promo :</p>
        <h2 style="color: #4e7662; font-weight: bold;">${customId}</h2>
      `,
      icon: "success",
      confirmButtonText: "Copier mon code",
      confirmButtonColor: "#4e7662"
    });
  };

  return (
    <AnimationRevealPage>
      <Light />
      <div className="container mt-5">
        <div className="card shadow-sm border-0" style={{ borderRadius: "15px" }}>
          <div className="card-body text-center p-5">
            <h3 style={{ color: "#333" }}>Mes Points de Fidélité</h3>
            
            <div className="row mt-4">
              <div className="col-md-6 border-end">
                <h5 className="text-muted">Total des Achats</h5>
                <p className="display-6" style={{ color: "#133B8C" }}>{data.total_amount} DH</p>
              </div>
              <div className="col-md-6">
                <h5 className="text-muted">Points Cumulés</h5>
                <p className="display-6" style={{ color: "#133B8C" }}>{data.points} PTS</p>
              </div>
            </div>

            {customId ? (
              <button 
                className="btn btn-lg mt-5 px-5" 
                style={{ backgroundColor: "#133B8C", color: "white", borderRadius: "30px" }}
                onClick={handleGetPromoCode}
              >
                PRENDRE MON CODE DE REMISE
              </button>
            ) : (
              <div className="alert alert-warning mt-4">
                Veuillez vous reconnecter pour accéder à vos points.
              </div>
            )}
          </div>
        </div>
      </div>
    </AnimationRevealPage>
  );
};

export default PointsPage;